export interface IReducedInfo {
  url: string;
  username: string;
  password: string;
}

export const COUCH_ONLINE_DAYS_BACK = 2;
